<template>
    <div>
        <label class="question-label" 
               :style="{
                     color: styles.question_color || '#333333',
                     fontSize: styles.question_size || '24px',
                     fontFamily: styles.question_font || 'Lato'
        }">
            <survey-page-editable
                attr="name"  :target="question" :editable="editable"
                placeholder="Your question title goes here."
                @changed="onEditableChange"
            />
            <span v-if="question.required && view!=='preview'" class="required tw-text-red-600">*</span>
        </label>
        <div class="question-description"
             :style="{
                     color: styles.question_color || '#333333',
                     fontSize: styles.question_size || '24px',
                     fontFamily: styles.question_font || 'Lato'}"
        >
            <survey-page-editable
                attr="description" :target="question" :editable="editable"
                placeholder="You can add optional question description here."
                @changed="onEditableChange"
            />&nbsp;
        </div>
        <component :is="`question-${question.type}`"
                   v-if="view!=='preview'"
                   :value="value"
                   v-model="value"
                   :config="question"
                   :readonly="readonly"
                   :editable="editable"
                   class="component"
                   :style="{
                       color: styles.answer_color || '#2f65b4',
                       fontSize: styles.answer_size || '24px',
                       fontFamily: styles.answer_font || 'Lato'
                   }"
                   :input-styles="{
                       color: styles.answer_color || '#2f65b4',
                       fontSize: styles.answer_size || '24px',
                       fontFamily: styles.answer_font || 'Lato'
                   }"
                   @answer="onAnswerInput"
                   @config="onConfigChange"
        />
        <p v-if="errors.required" class="tw-text-red-600 tw-text-sm tw-mt-4">
            This question is required
        </p>
    </div>
</template>

<script>

import QuestionShortText from "@/components/Questions/ShortText";
import QuestionEmail from "@/components/Questions/Email";
import QuestionPhoneNumber from "@/components/Questions/PhoneNumber";
import QuestionDate from "@/components/Questions/Date";
import QuestionWebsite from "@/components/Questions/Website";
import QuestionNumber from "@/components/Questions/Number";
import QuestionLongText from "@/components/Questions/LongText";
import QuestionSingleChoice from "@/components/Questions/SingleChoice";
import QuestionMultipleChoice from "@/components/Questions/MultipleChoice";
import QuestionOpinionScale from "@/components/Questions/OpinionScale";
import QuestionRating from "@/components/Questions/Rating";
import QuestionRanking from "@/components/Questions/Ranking";
import QuestionBoolean from "@/components/Questions/Boolean";
import SurveyPageEditable from "@/pages/surveys/SurveyPageEditable.vue";
import {debounce} from "lodash-es";

export default {
    name: 'QuestionView',
    components: {
        SurveyPageEditable,
        QuestionShortText,
        QuestionEmail,
        QuestionPhoneNumber,
        QuestionDate,
        QuestionWebsite,
        QuestionNumber,
        QuestionLongText,
        QuestionSingleChoice,
        QuestionMultipleChoice,
        QuestionOpinionScale,
        QuestionRating,
        QuestionRanking,
        QuestionBoolean,
    },
    props: {
        question: {
            type: Object,
            required: true
        },
        readonly: {
            type: Boolean,
            default: false
        },
        editable: {
            type: Boolean,
            default: false
        },
        storePrefix: {
            type: String,
            default: 'survey'
        },
        view: {
            type: String,
        },
        styles: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            value: null,
            errors: {}
        }
    },
    watch: {
        'question.id'() {
            this.value = this.storedValue;
        },
    },
    mounted() {
        this.value = this.storedValue;
    },
    computed: {
        storedValue() {
            const response = this.$store.getters['surveyResponses/selected'];
            if (response) {
                return response.answers[this.question.id]?.value ?? this.question.default;
            }
            return this.question.default;
        }
    },
    methods: {
        async onEditableChange(payload) {
            await this.$store.dispatch(`${this.storePrefix}Questions/update`, payload);
        },
        onAnswerInput(answer) {
            this.$emit('answer', answer);
        },
        onConfigChange(changes) {
            this.$store.dispatch(`${this.storePrefix}Questions/update`, {
                id: this.question.id,
                ...changes
            })
        }
    },
}
</script>
